<template>
  <div class="service__card" v-if="card && title" width="300">
    <div class="service__card__inner">
      <div class="service__card__category" v-if="categories">
        <div class="service__card__actions">
          <button class="service__card__edit" @click="editNote(card.id)">
            Edit
          </button>
          <button class="service__card__edit" @click="showNote(card.id)">
            Show
          </button>
          <button class="service__card__edit" @click="toggle()">
            {{ label }}
          </button>
        </div>
        <h6 :style="{ backgroundColor: getColor(categories) }">
          {{ categories }}
        </h6>
      </div>
      <div class="service__card__title">
        <h4 :style="{ backgroundColor: getColor(categories) }">{{ title }}</h4>
      </div>
      <div
        class="service__card__description"
        v-html="description"
        v-if="computedOpen && description"
      ></div>
      <div
        class="d-flex flex-column service__card__steps"
        v-if="computedOpen && subitems.length > 0"
      >
        <div
          class="service__card__step"
          v-for="(chip, index) in subitems"
          :key="`${card.id}-sub${chip.title}-${index}`"
        >
          {{ chip }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "UserServiceCard",
  data() {
    return {
      open: false,
    };
  },
  props: {
    card: Object,
    all: Array,
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.item ? this.item.title : null;
    },
    categories() {
      return this.item ? this.item.categories : null;
    },
    description() {
      return this.item ? this.item.description : null;
    },
    subitems() {
      return this.item ? this.item.subitems : null;
    },
    item() {
      return this.all.find((x) => x.id == this.card.id);
    },
    computedOpen() {
      return this.isOpen || this.open ? true : false;
    },
    exapndable() {
      if (this.subitems || this.description) {
        return this.subitems || this.description ? true : false;
      } else {
        return this.description ? true : false;
      }
    },
    label() {
      return this.open ? "Close" : "Expand";
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    editNote(id) {
      this.$emit("editNote", id);
    },
    showNote(id) {
      this.$emit("showNote", id);
    },
    getColor(cat) {
      switch (cat) {
        case "Digital":
          return "#b85cce";
        case "Physical":
          return "#02b0d1";
        case "Logistics":
          return "#87969d";
        case "Opportunity":
          return "#8BC34A";
        case "Bottleneck":
          return "#F44336";
        default:
          return "grey";
      }
    },
  },
};
</script>
